import React from 'react';

interface NotificationProps {
  show: boolean;
  onClose: () => void;
  message: string;
}

const Notification: React.FC<NotificationProps> = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-80 text-center">
        <p className="text-lg text-gray-800 mb-4">{message}</p>
        <button
          onClick={onClose}
          className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Notification;
